import { DECIMAL_PLACES } from '@/src/constants';
import { extractAmountValue } from '@/src/helpers';
import { OfferSide } from '@/src/models';
import { AccountOffer } from 'xrpl';

type UseAccountOfferValuesProps = {
  offer: AccountOffer;
  offerType: OfferSide;
};

export const useAccountOfferValues = ({ offer, offerType }: UseAccountOfferValuesProps) => {
  if (!offerType) return { amount: '0', total: '0', price: '0' };

  const { taker_gets, taker_pays } = offer;

  const isBuy = offerType === 'buy';

  const amount = extractAmountValue(isBuy ? taker_pays : taker_gets);
  const total = extractAmountValue(isBuy ? taker_gets : taker_pays);
  const price = (Number(total) / Number(amount)).toFixed(DECIMAL_PLACES);

  return { amount, total, price };
};
